/**
 * Database Client - Platform-agnostic export
 * Kiest de juiste database op basis van waar we draaien
 */

import { Platform } from 'react-native';

// De juiste implementatie kiezen
let databaseClient;

if (Platform.OS === 'web') {
  // Web versie (IndexedDB)
  databaseClient = require('./database.web').databaseClient;
} else {
  // Native versie (SQLite)
  databaseClient = require('./database.native').databaseClient;
}

export { databaseClient };
export type { DatabaseService } from './DatabaseService';
